export default class Roles {
    static SuperAdmin = 'Super Admin';
    static DistrictAdmin = 'District Admin';
    static SchoolAdmin = 'School Admin';
    static Teacher = 'Teacher';
    static Student = 'Student';
}
